import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, ReplaySubject } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { User } from 'app/core/user/user.types';
import { environment } from 'environments/environment';
import { BaseRespone } from '../models/common.response';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user data
     */
    get(): Observable<BaseRespone<User>> {
        return this._httpClient.get<BaseRespone<User>>(`${environment.baseUrl}/User`)
            .pipe(
                tap((response) => {
                    this._user.next(response.result);
                })
            );
    }

    /**
     * Update the user
     *
     * @param user
     */
    update(user: User): Observable<any> {
        return this._httpClient.patch<User>(`'api/common/user'`, { user }).pipe(
            map((response) => {
                this._user.next(response);
            })
        );
    }

    /**
 * Change user password
 *
 * @param credentials Object containing current and new password
 */
    changePassword(credentials: { currentPassword: string; newPassword: string }): Observable<BaseRespone<boolean>> {
        return this._httpClient.post<BaseRespone<boolean>>(`${environment.baseUrl}/Auth/change-password`, credentials).pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }
}
